import { useMemo, useState } from 'react';
import { registerUser, isStrongPassword } from '../api/auth/auth';
import { useNavigate, Link } from 'react-router-dom';
import '../../src/assets/styles/register.scss';

export default function Register() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const rules = useMemo(() => {
    const lengthOk = password.length >= 8;
    const upperOk = /[A-ZĄĆĘŁŃÓŚŹŻ]/.test(password);
    const digitOk = /\d/.test(password);
    return { lengthOk, upperOk, digitOk };
  }, [password]);

  const strong = useMemo(() => {
    return isStrongPassword(password) && rules.lengthOk && rules.upperOk && rules.digitOk;
  }, [password, rules]);

  const match = password.length > 0 && password === password2;

  const canSubmit = strong && match && !!email.trim() && !submitting;

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    if (submitting || !canSubmit) return;

    setSubmitting(true);
    try {
      await registerUser(email.trim(), password, name.trim() || undefined);
      alert('Zarejestrowano. Sprawdź pocztę i kliknij link weryfikacyjny.');
      navigate('/admin/login', { replace: true });
    } catch (e) {
      alert('Rejestracja nieudana');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login-wrap">
      <section className="login-card">
        <h1 style={{ padding: '24px 24px 0', margin: 0, fontSize: 22 }}>Rejestracja</h1>

        <form onSubmit={handleRegister} className="login-form" noValidate>
          <label className="login-label">
            Imię (opcjonalnie)
            <input
              className="login-input"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="np. Jan"
              autoComplete="given-name"
            />
          </label>
          <label className="login-label">
            Email
            <input
              className="login-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="np. jan.kowalski@example.com"
              autoComplete="email"
              required
            />
          </label>

          <label className="login-label">
            Hasło
            <input
              className="login-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Min. 8 znaków, 1 wielka litera i 1 cyfra"
              autoComplete="new-password"
              required
              aria-describedby="pw-help"
            />
          </label>

          <div className={`pw-meter ${strong ? 'ok' : 'bad'}`} aria-hidden />

          <ul id="pw-help" className="pw-checklist">
            <li className={rules.lengthOk ? 'ok' : ''}>Min. 8 znaków</li>
            <li className={rules.upperOk ? 'ok' : ''}>Co najmniej 1 wielka litera</li>
            <li className={rules.digitOk ? 'ok' : ''}>Co najmniej 1 cyfra</li>
          </ul>

          <label className="login-label">
            Powtórz hasło
            <input
              className={`login-input ${password2 && !match ? 'input-error' : ''}`}
              type="password"
              value={password2}
              onChange={e => setPassword2(e.target.value)}
              placeholder="Wpisz to samo hasło"
              autoComplete="new-password"
              required
            />
          </label>

          {!match && password2.length > 0 && (
            <div className="input-hint error">Hasła nie są identyczne.</div>
          )}

          <button className="login-button" type="submit" disabled={!canSubmit}>
            {submitting ? 'Rejestrowanie…' : 'Zarejestruj'}
          </button>
        </form>

        <p className="below-form">
          Masz konto? <Link to="/admin/login">Zaloguj się</Link>
        </p>
      </section>
    </main>
  );
}
